import {useMemo} from 'react'

import type {Build} from '../../../../../../../services/rest'

function usePipelineRunJobProgress(mainPercentage: number, builds?: Build[]) {
  const progressPercentages = useMemo(() => {
    if (Array.isArray(builds)) {
      return builds
        .reduce<number[]>((percentages, build) => {
          const percentage = build?.['running-info']?.percentageComplete

          if (Number.isInteger(percentage)) {
            percentages.push(percentage!)
          }

          return percentages
        }, [])
        .sort((currentPercentage, nextPercentage) => nextPercentage - currentPercentage)
    }

    return [mainPercentage]
  }, [mainPercentage, builds])
  const percentagesLength = progressPercentages.length
  const maxHeight = 100
  const progresBarHeight = maxHeight / percentagesLength

  return {
    progressPercentages,
    progresBarHeight,
  }
}

export default usePipelineRunJobProgress
